import * as React from 'react';

var _defs, _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function SvgStarGolden(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.711,
    height: "0.625rem",
    viewBox: "0 0 16.711 16",
    className: "StarGolden_svg__profileCard__ribbon__icon",
    style: {
      marginRight: 2
    }
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "StarGolden_svg__a",
    x1: 0.069,
    y1: 0.089,
    x2: 1.204,
    y2: 1.389,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffe259"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.392,
    stopColor: "#ffe259"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffa751"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M153.846 16a1.089 1.089 0 01-.507-.125l-3.983-2.094-3.983 2.094a1.09 1.09 0 01-1.581-1.149l.761-4.436-3.223-3.141a1.09 1.09 0 01.6-1.859l4.453-.647 1.995-4.035a1.09 1.09 0 011.955 0l1.992 4.036 4.454.647a1.09 1.09 0 01.6 1.859l-3.223 3.141.761 4.436A1.09 1.09 0 01153.846 16z",
    transform: "translate(-141)",
    fill: "url(#StarGolden_svg__a)"
  })));
}

export { SvgStarGolden as ReactComponent };
//# sourceMappingURL=StarGolden.svg.js.map
